export const conversationFilterModeForVisibility = ({
  visibleTeamIds = [],
  filterAssignedOnly = false,
  filterUnassignedOnly = false,
} = {}) => {
  const hasVisibleTeams = visibleTeamIds.length > 0;

  if (hasVisibleTeams && filterAssignedOnly && filterUnassignedOnly) {
    return 'team_unassigned_or_mine';
  }

  if (hasVisibleTeams && !filterAssignedOnly && !filterUnassignedOnly) {
    return 'team_conversations_only';
  }

  if (!hasVisibleTeams && filterAssignedOnly && !filterUnassignedOnly) {
    return 'assigned_conversations_only';
  }

  if (!hasVisibleTeams && !filterAssignedOnly && filterUnassignedOnly) {
    return 'unassigned_conversations_only';
  }

  return 'all_conversations';
};
